import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { SummaryItem } from '../../models';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss',
})
export class SummaryComponent {
  @Input() model$: Observable<any>;
  @Input() summaryItems: (model: any) => SummaryItem[];
}
